import {IconProps} from '../../types/IconProps'

const CrossIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '11'}
      height={height || '11'}
      viewBox='0 0 11 11'
      fill={'none'}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.317572 0.161091C0.52926 -0.0536971 0.872473 -0.0536971 1.08416 0.161091L5.5 4.64162L9.91584 0.161091C10.1275 -0.0536971 10.4707 -0.0536971 10.6824 0.161091C10.8941 0.37588 10.8941 0.72412 10.6824 0.938909L6.26659 5.41943L10.8412 10.0611C11.0529 10.2759 11.0529 10.6241 10.8412 10.8389C10.6295 11.0537 10.2863 11.0537 10.0746 10.8389L5.5 6.19725L0.925354 10.8389C0.713666 11.0537 0.370453 11.0537 0.158766 10.8389C-0.0529219 10.6241 -0.0529219 10.2759 0.158766 10.0611L4.73341 5.41943L0.317572 0.938909C0.105885 0.72412 0.105885 0.37588 0.317572 0.161091Z'
        fill={color || '#666666'}
      />
    </svg>
  )
}

export default CrossIcon
